import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

// Configuration for persisting slices
export const persistAuthConfig = {
  key: 'auth',
  storage,
  whitelist: ['userAuth'], // Only persist userAuth part of the state
};

export const persistUserConfig = {
  key: 'user',
  storage,
  whitelist: ['userDocProfileData', 'usersProfileData'], // Persist user profile data
};

export const persistHandoverConfig = {
  key: 'handover',
  storage,
  whitelist: ['taskDocData'], // Only persist taskDocData, not handoverDocData (managed by RTK Query)
};

export const persistHandoverTaskConfig = {
  key: 'handoverTask',
  storage,
  whitelist: ['handoverTask'], // Persist handoverTask state (if needed)
};

export const persistHandoverCommentConfig = {
  key: 'handoverComment',
  storage,
  whitelist: ['comments'], // Persist handover comments
};
